export const GET_TEMPLATES_STATS_SUCCESS = 'GET_TEMPLATES_STATS_SUCCESS';

export const GET_SENT_TEMPLATES_STATS_SUCCESS = 'GET_SENT_TEMPLATES_STATS_SUCCESS';

export const RESET_APPLICATION_STATS_SUCCESS = 'RESET_APPLICATION_STATS_SUCCESS';
